module.exports = __webpack_public_path__ + "static/media/fish-head.abe3dae4.svg";